import { render, staticRenderFns } from "./ModalJunior.vue?vue&type=template&id=5fa7dbc9&scoped=true&"
import script from "./ModalJunior.vue?vue&type=script&lang=js&"
export * from "./ModalJunior.vue?vue&type=script&lang=js&"
import style0 from "./ModalJunior.vue?vue&type=style&index=0&id=5fa7dbc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7dbc9",
  null
  
)

export default component.exports